export const environment = {
  production: true,
  rootUrl: 'https://api.policliniconapoli.it',
  wpUrl: 'https://api.policliniconapoli.it/backoffice/wp-json/wp/v2/'
};